(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('CmsListCheckListsController', CmsListCheckListsController);

  /* ngInject */
  function CmsListCheckListsController(cmsCheckListService, publishedStatuses, sessionService) {

    const vm = this;

    vm.checkLists = [];
    vm.getCheckLists = getCheckLists;
    vm.order = '-updated_at';
    vm.orderBy = orderBy;
    vm.publishedStatusFilter = 'published';
    vm.publishedStatuses = publishedStatuses;

    vm.getCheckLists();

    function getCheckLists() {
      cmsCheckListService(sessionService.getAuthToken()).query(response => vm.checkLists = response);
    }

    function orderBy(field) {
      if (vm.order.includes(field)) {
        if (vm.order.substr(0, 1) == '-') {
          vm.order = field;
        } else {
          vm.order = '-' + field;
        }
      } else {
        vm.order = field;
      }
    }
  }
})();
